import React from 'react';
import { FaBuilding, FaTint, FaHardHat, FaWater, FaPaintRoller, FaTools } from 'react-icons/fa';
import { motion } from 'framer-motion';

const Services = () => {
  const services = [
    {
      icon: FaBuilding,
      title: "RCC Structural",
      description: "We specialize in reinforced cement concrete (RCC) structural work, ensuring robust and durable frameworks for buildings, bridges, and infrastructure. Our expertise guarantees precision engineering and adherence to safety standards.",
    },
    {
      icon: FaTint,
      title: "Waterproofing Building",
      description: "Our waterproofing services provide essential protection against water intrusion, preventing leaks and enhancing the longevity of your building. From roofs to basements, we offer effective solutions for all types of structures.",
    },
    {
      icon: FaHardHat,
      title: "Building Construction",
      description: "From concept to completion, our comprehensive building construction services cover every aspect of your project. We focus on delivering high-quality structures while maintaining timelines and budget constraints.",
    },
    {
      icon: FaWater,
      title: "Guniting Sand",
      description: "Our guniting services involve applying high-pressure sand and cement mixtures to create durable, long-lasting surfaces for concrete repair, stabilization, and lining of water structures.",
    },
    {
      icon: FaPaintRoller,
      title: "Epoxy Work",
      description: "We offer high-performance epoxy coatings to protect floors, walls, and structures from chemical exposure, abrasion, and impact. Our epoxy services are ideal for industrial, commercial, and residential applications.",
    },
    {
      icon: FaTools,
      title: "Maintenance Services",
      description: "Our maintenance services ensure that your buildings and structures remain in top condition. We provide regular inspections, repairs, and upgrades to keep your property safe and functional.",
    },
  ];

  return (
    <section className="bg-gray-50 py-16 sm:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 items-stretch">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <motion.li
                key={service.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.45, delay: (index % 3) * 0.08 }}
                className="group relative flex h-full flex-col overflow-hidden rounded-2xl border border-gray-200 bg-white p-7 sm:p-8 shadow-md transition-all duration-300 hover:-translate-y-1 hover:border-brand-yellow hover:shadow-xl"
              >
                <span className="absolute right-0 top-0 h-24 w-24 rounded-bl-full bg-brand-yellow/0 transition-colors duration-300 group-hover:bg-brand-yellow/25" aria-hidden="true" />
                <span className="relative flex h-16 w-16 items-center justify-center rounded-2xl bg-brand-navy text-3xl text-brand-yellow shadow-md transition-colors duration-300 group-hover:bg-brand-yellow group-hover:text-brand-navy">
                  <Icon aria-hidden="true" />
                </span>
                <h3 className="relative mt-6 text-xl sm:text-2xl font-bold text-brand-navy">{service.title}</h3>
                <div className="relative mt-3 h-1 w-10 rounded-full bg-brand-yellow transition-all duration-300 group-hover:w-16" />
                <p className="relative mt-4 text-sm sm:text-base leading-relaxed text-gray-700">{service.description}</p>
              </motion.li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};

export default Services;
